import { render } from "./selex.vue?vue&type=template&id=1372b21f&scoped=true&lang=pug"
import script from "./selex.vue?vue&type=script&lang=js"
export * from "./selex.vue?vue&type=script&lang=js"

import "./selex.vue?vue&type=style&index=0&id=1372b21f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1372b21f"]])

export default __exports__